<template>
    <div class="main">
        
        <el-tabs v-model="aba" type="border-card">

            <!-- ========== PROCEDÊNCIA ========== -->
            <el-tab-pane label="Procedência (escolas anteriores)" name="procedencia">
                <el-form :inline="true" @submit.native.prevent="addProcedencia" class="u-mb-10">
                    <el-form-item label="Ano">
                        <el-input-number v-model="novaProc.ano" :min="1900" :max="2100" :controls="false" style="width:90px;"></el-input-number>
                    </el-form-item>
                    <el-form-item label="Escola de origem">
                        <el-input v-model="novaProc.nome_escola" style="width:240px;"></el-input>
                    </el-form-item>
                    <el-form-item label="Município">
                        <el-input v-model="novaProc.municipio" style="width:140px;"></el-input>
                    </el-form-item>
                    <el-form-item label="UF">
                        <el-input v-model="novaProc.uf" maxlength="2" style="width:60px;"></el-input>
                    </el-form-item>
                    <el-form-item label="Série">
                        <el-input v-model="novaProc.serie" style="width:120px;"></el-input>
                    </el-form-item>
                    <el-form-item>
                        <el-button type="primary" icon="el-icon-plus" @click="addProcedencia">ADICIONAR</el-button>
                    </el-form-item>
                </el-form>

                <table class="table table-striped">
                    <thead><tr>
                        <th style="width:70px;">Ano</th><th>Escola</th><th style="width:150px;">Município/UF</th>
                        <th style="width:120px;">Série</th><th style="width:70px;" class="u-text-center">Ação</th>
                    </tr></thead>
                    <tbody>
                        <tr v-for="p in procedencias" :key="p.id">
                            <td>{{ p.ano || '—' }}</td>
                            <td>{{ p.nome_escola }}</td>
                            <td>{{ (p.municipio || '—') }}{{ p.uf ? ' / ' + p.uf : '' }}</td>
                            <td>{{ p.serie || '—' }}</td>
                            <td class="u-text-center"><el-button size="mini" type="danger" plain icon="el-icon-delete" @click="del('procedencia-aluno', p.id, 'procedencia')"></el-button></td>
                        </tr>
                        <tr v-if="!procedencias.length"><td colspan="5" class="u-text-center" style="padding:16px;color:#909399;">Nenhuma procedência registrada.</td></tr>
                    </tbody>
                </table>
            </el-tab-pane>

            <!-- ========== DEPENDÊNCIA ========== -->
            <el-tab-pane label="Dependência" name="dependencia">
                <el-form :inline="true" @submit.native.prevent="addDependencia" class="u-mb-10">
                    <el-form-item label="Ano">
                        <el-input-number v-model="novaDep.ano" :min="1900" :max="2100" :controls="false" style="width:90px;"></el-input-number>
                    </el-form-item>
                    <el-form-item label="Disciplina">
                        <el-select v-model="novaDep.area_conhecimento_id" filterable placeholder="Selecione" style="width:240px;">
                            <el-option v-for="d in disciplinas" :key="d.id" :label="d.nome_area" :value="d.id"></el-option>
                        </el-select>
                    </el-form-item>
                    <el-form-item label="Situação">
                        <el-select v-model="novaDep.situacao" style="width:150px;">
                            <el-option :value="1" label="Em dependência"></el-option>
                            <el-option :value="2" label="Quitada"></el-option>
                        </el-select>
                    </el-form-item>
                    <el-form-item>
                        <el-button type="primary" icon="el-icon-plus" @click="addDependencia">ADICIONAR</el-button>
                    </el-form-item>
                </el-form>

                <table class="table table-striped">
                    <thead><tr>
                        <th style="width:70px;">Ano</th><th>Disciplina</th><th style="width:150px;">Situação</th>
                        <th style="width:70px;" class="u-text-center">Ação</th>
                    </tr></thead>
                    <tbody>
                        <tr v-for="d in dependencias" :key="d.id">
                            <td>{{ d.ano || '—' }}</td>
                            <td>{{ d.disciplina ? d.disciplina.nome_area : '—' }}</td>
                            <td>{{ d.situacao === 2 ? 'Quitada' : 'Em dependência' }}</td>
                            <td class="u-text-center"><el-button size="mini" type="danger" plain icon="el-icon-delete" @click="del('dependencia-aluno', d.id, 'dependencia')"></el-button></td>
                        </tr>
                        <tr v-if="!dependencias.length"><td colspan="4" class="u-text-center" style="padding:16px;color:#909399;">Nenhuma dependência registrada.</td></tr>
                    </tbody>
                </table>
            </el-tab-pane>

            <!-- ========== DISPENSA ========== -->
            <el-tab-pane label="Dispensa" name="dispensa">
                <el-form :inline="true" @submit.native.prevent="addDispensa" class="u-mb-10">
                    <el-form-item label="Ano">
                        <el-input-number v-model="novaDisp.ano" :min="1900" :max="2100" :controls="false" style="width:90px;"></el-input-number>
                    </el-form-item>
                    <el-form-item label="Disciplina">
                        <el-select v-model="novaDisp.area_conhecimento_id" filterable placeholder="Selecione" style="width:240px;">
                            <el-option v-for="d in disciplinas" :key="d.id" :label="d.nome_area" :value="d.id"></el-option>
                        </el-select>
                    </el-form-item>
                    <el-form-item label="Motivo">
                        <el-input v-model="novaDisp.motivo" style="width:260px;"></el-input>
                    </el-form-item>
                    <el-form-item>
                        <el-button type="primary" icon="el-icon-plus" @click="addDispensa">ADICIONAR</el-button>
                    </el-form-item>
                </el-form>

                <table class="table table-striped">
                    <thead><tr>
                        <th style="width:70px;">Ano</th><th style="width:220px;">Disciplina</th><th>Motivo</th>
                        <th style="width:70px;" class="u-text-center">Ação</th>
                    </tr></thead>
                    <tbody>
                        <tr v-for="d in dispensas" :key="d.id">
                            <td>{{ d.ano || '—' }}</td>
                            <td>{{ d.disciplina ? d.disciplina.nome_area : '—' }}</td>
                            <td>{{ d.motivo || '—' }}</td>
                            <td class="u-text-center"><el-button size="mini" type="danger" plain icon="el-icon-delete" @click="del('dispensa-aluno', d.id, 'dispensa')"></el-button></td>
                        </tr>
                        <tr v-if="!dispensas.length"><td colspan="4" class="u-text-center" style="padding:16px;color:#909399;">Nenhuma dispensa registrada.</td></tr>
                    </tbody>
                </table>
            </el-tab-pane>

        </el-tabs>
        
    </div>
</template>

<script>
export default {
    data () {
        const anoAtual = new Date().getFullYear()
        return {
            alunoId: this.$route.params.aluno_id,
            aba: 'procedencia',
            disciplinas: [],
            procedencias: [], dependencias: [], dispensas: [],
            novaProc: { ano: anoAtual, nome_escola: '', municipio: '', uf: '', serie: '' },
            novaDep: { ano: anoAtual, area_conhecimento_id: null, situacao: 1 },
            novaDisp: { ano: anoAtual, area_conhecimento_id: null, motivo: '' }
        }
    },
    mounted () {
        this.carregarDisciplinas()
        this.carregar('procedencia')
        this.carregar('dependencia')
        this.carregar('dispensa')
    },
    methods: {
        baseUrl () { return this.$store.state.config.baseUrlApi },
        endpointDe (aba) { return { procedencia: 'procedencia-aluno', dependencia: 'dependencia-aluno', dispensa: 'dispensa-aluno' }[aba] },
        listaDe (aba) { return { procedencia: 'procedencias', dependencia: 'dependencias', dispensa: 'dispensas' }[aba] },

        carregarDisciplinas () {
            this.$axios.get(`${this.baseUrl()}/api/area-conhecimento/getAll`, this.$store.getters.getHeaderAuth)
                .then(r => { this.disciplinas = Array.isArray(r.data) ? r.data : (r.data && r.data.data ? r.data.data : []) })
                .catch(() => {})
        },
        carregar (aba) {
            this.$axios.get(`${this.baseUrl()}/api/${this.endpointDe(aba)}/getByAluno/${this.alunoId}`, this.$store.getters.getHeaderAuth)
                .then(r => { this[this.listaDe(aba)] = Array.isArray(r.data) ? r.data : [] })
                .catch(e => this.$store.commit('throwException', e))
        },
        salvar (endpoint, payload, aba, resetFn) {
            this.$axios.post(`${this.baseUrl()}/api/${endpoint}/store`, { ...payload, aluno_id: this.alunoId }, this.$store.getters.getHeaderAuth)
                .then(r => {
                    if (r.data && r.data.erro) {
                        window.eventBus.$emit('alert', { msg: typeof r.data.erro === 'string' ? r.data.erro : r.data.erro.text, type: 'warning' })
                        return
                    }
                    window.eventBus.$emit('alert', { msg: 'Registrado.', type: 'success' })
                    resetFn()
                    this.carregar(aba)
                }).catch(e => this.$store.commit('throwException', e))
        },
        addProcedencia () {
            if (!this.novaProc.nome_escola) { window.eventBus.$emit('alert', { msg: 'Informe a escola de origem.', type: 'warning' }); return }
            this.salvar('procedencia-aluno', this.novaProc, 'procedencia', () => {
                this.novaProc = { ano: new Date().getFullYear(), nome_escola: '', municipio: '', uf: '', serie: '' }
            })
        },
        addDependencia () {
            if (!this.novaDep.area_conhecimento_id) { window.eventBus.$emit('alert', { msg: 'Selecione a disciplina.', type: 'warning' }); return }
            this.salvar('dependencia-aluno', this.novaDep, 'dependencia', () => {
                this.novaDep = { ano: new Date().getFullYear(), area_conhecimento_id: null, situacao: 1 }
            })
        },
        addDispensa () {
            if (!this.novaDisp.area_conhecimento_id) { window.eventBus.$emit('alert', { msg: 'Selecione a disciplina.', type: 'warning' }); return }
            this.salvar('dispensa-aluno', this.novaDisp, 'dispensa', () => {
                this.novaDisp = { ano: new Date().getFullYear(), area_conhecimento_id: null, motivo: '' }
            })
        },
        del (endpoint, id, aba) {
            this.$confirm('Excluir registro?', 'Confirmar', { type: 'warning' }).then(() => {
                this.$axios.delete(`${this.baseUrl()}/api/${endpoint}/delete/${id}`, this.$store.getters.getHeaderAuth)
                    .then(() => this.carregar(aba))
                    .catch(e => this.$store.commit('throwException', e))
            }).catch(() => {})
        }
    }
}
</script>
